import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useAlertContext } from 'components/styled/alert/context'
import { Alert } from 'components/styled/alert/index'

type StyleType = 'warning' | 'danger' | 'success' | 'info'
type MessageType = {
  style: StyleType
  id: string
  text: string
}
interface AlertListProps {
  messages?: MessageType[]
  removeMessage?: (messageId: string) => void
  closeAfterTimeout?: boolean
}

const StyledAlertList = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  max-width: 90%;
`
const messageVariant = (style: StyleType) => {
  switch (style) {
    case 'warning':
      return 'warn'
    case 'danger':
      return 'error'
    default:
      return style
  }
}

export const AlertList = ({
  messages,
  removeMessage,
  closeAfterTimeout = false,
}: AlertListProps) => {
  const { openAlerts, onOpenAlert } = useAlertContext()

  useEffect(() => {
    if (messages && messages.length > 0) {
      messages.forEach((message: MessageType) => {
        onOpenAlert({
          id: message.id,
          variant: messageVariant(message.style),
          title: message.text,
          closeAfterTimeout,
          closeTimeoutMs: 6000,
        })

        if (removeMessage) {
          removeMessage(message.id)
        }
      })
    }
  }, [messages, openAlerts])

  return (
    <StyledAlertList>
      {openAlerts.map(alert => (
        <Alert key={alert.id} {...alert} />
      ))}
    </StyledAlertList>
  )
}
